import { Loading } from '@commenda/kakashi';
import ReactMarkdown, { Components } from 'react-markdown';
import useGlossaryEntry from '../api/useGlossaryEntry';

const CommendapediaEntry = ({
  entryId,
  token,
  renderers,
}: {
  entryId: number;
  token: string;
  // Custom components: https://github.com/remarkjs/react-markdown?tab=readme-ov-file#appendix-b-components
  renderers?: Partial<Components>;
}) => {
  const { data, error } = useGlossaryEntry(entryId, token);

  if (!data) {
    if (error) console.error(error);

    return (
      <div
        style={{ height: 'calc(100vh - 320px)' }}
        className="flex justify-center items-center"
      >
        <Loading />
      </div>
    );
  }

  if (!data?.attributes) {
    return <div />;
  }

  return (
    <ReactMarkdown components={renderers}>{data.attributes.body}</ReactMarkdown>
  );
};

export default CommendapediaEntry;
